/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { notificationModelSchema } from "./notificationModelSchema.ts";
import { z } from "zod";

export const notificationModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => notificationModelSchema))
    })